import React from "react"
import { Link, NavLink } from "react-router-dom"
import "./Header.scss"
import Logo from "../Logo"
import CalendarDropdownWithStore from "../CalendarDropdown/CalendarDropdownWithStore"
import UserNav from "../UserNav"
import PropTypes from "prop-types"
import { NavbarBrand, NavbarToggler, Collapse, Nav, NavItem } from "reactstrap"
import routes from "../../routes"
import { formatRoute } from "../../helpers/sharedHelperFunctions"
import { getEntityTypeMapping } from "../../helpers/sharedHelperFunctions"

const entityTypeToTabs = {
  facility: ["departments", "units", "roles", "staff", "rooms"],
  department: ["units", "roles", "staff", "rooms"],
}

class Header extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
    }
  }

  toggleDropdown = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  render() {
    const linkUrl = this.props.defaultEntity
      ? routes.root
      : formatRoute(routes.overview, {
          entityType: this.props.entityType,
          entityId: this.props.entityId,
        })

    const isRoundingMonitor =
      this.props.location &&
      this.props.location.pathname.includes("roundingMonitor")

    return (
      <header className="Header navbar navbar-expand-lg navbar-dark">
        <NavbarBrand tag={Link} to={formatRoute(routes.root)}>
          {isRoundingMonitor ? null : <Logo />}
        </NavbarBrand>
        <NavbarToggler
          class="hidden-xl"
          tag="navbar-toggle"
          onClick={this.toggleDropdown}
        />
        {!isRoundingMonitor && (
          <Collapse isOpen={this.state.isOpen} navbar>
            <NavItem className="current-entity">
              <Link to={linkUrl}>{this.props.entityName}</Link>
            </NavItem>
            <HeaderNav {...this.props} />
            <div className="end-nav">
              <CalendarDropdownWithStore />
              <UserNav
                initials={this.props.userInitials}
                applications={this.props.applications}
              />
            </div>
          </Collapse>
        )}
      </header>
    )
  }
}

Header.propTypes = {
  entityName: PropTypes.string,
  location: PropTypes.object, // Redux router.location object for building links.
  entityId: PropTypes.string,
  entityType: PropTypes.oneOf(["network", "facility", "department"]),
  defaultEntity: PropTypes.bool,
  applications: UserNav.propTypes.applications,
  userInitials: UserNav.propTypes.initials,
}

const HeaderNav = ({ entityId, entityType, location, defaultEntity }) => {
  if (!entityId || !entityType || !location || defaultEntity) return null

  const overviewTab = {
    label: "Overview",
    url: formatRoute(routes.overview, {
      entityType,
      entityId,
    }),
  }

  const entityTabs = entityTypeToTabs[entityType].map(childEntityType => {
    const { pluralShortDisplay, pluralRoute } = getEntityTypeMapping(
      childEntityType
    )
    return {
      label: `All ${pluralShortDisplay}`,
      url: formatRoute(routes.detail, {
        entityType,
        entityId,
        childEntityType: pluralRoute,
      }),
    }
  })

  const tabs = [overviewTab].concat(entityTabs)

  return (
    <Nav navbar>
      {tabs.map((tab, i) => {
        return (
          <NavItem key={tab.url}>
            <NavLink
              exact
              to={tab.url}
              location={location}
              className="nav-link"
              activeClassName="active"
            >
              {tab.label}
            </NavLink>
          </NavItem>
        )
      })}
    </Nav>
  )
}

HeaderNav.propTypes = {
  entityId: Header.propTypes.entityId,
  entityType: Header.propTypes.entityType,
  location: Header.propTypes.location,
  defaultEntity: Header.propTypes.defaultEntity,
}

export default Header
